import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: #fff;\n  border-radius: ", ";\n  bottom: 20px;\n  left: 20px;\n  max-height: 50vh;\n  overflow: auto;\n  position: absolute;\n  right: 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import MediaQuery from 'react-responsive';
import { BaseModal } from '../Modal';
import styled, { useTheme } from '../utils/styling/styled-components';
import { Popover } from './Popover';
var PopoverModal = styled(BaseModal)(_templateObject(), function (props) {
  return props.theme.borderRadius.medium;
});
/**
 * Responsive Popover component. Converts to modal at defined breakpoint
 */

export var ResponsivePopover = function ResponsivePopover(_ref) {
  var _theme$breakpoints;

  var children = _ref.children,
      breakpoint = _ref.breakpoint,
      props = _objectWithoutProperties(_ref, ["children", "breakpoint"]);

  var theme = useTheme();
  var resolvedBreakpoint = breakpoint !== null && breakpoint !== void 0 ? breakpoint : theme === null || theme === void 0 ? void 0 : (_theme$breakpoints = theme.breakpoints) === null || _theme$breakpoints === void 0 ? void 0 : _theme$breakpoints.sm;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: resolvedBreakpoint
  }, children, /*#__PURE__*/React.createElement(PopoverModal, {
    onRequestClose: props.onOutsideClick,
    isOpen: props.visible
  }, props.content)), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: resolvedBreakpoint + 1
  }, /*#__PURE__*/React.createElement(Popover, props, children)));
};